<!doctype html>
<html lang="en">

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0" />
    <meta name="theme-color" content="#ffffff" />
    <meta name="color-scheme" content="only light" />
    <meta name="description" content="VERDE TRADER Leads" />
    <meta name="version" content="%VITE_VERSION%" />
    <meta name="robots" content="noindex, nofollow" />
    <title>VERDE TRADER Leads</title>
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Bold.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-BoldItalic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-ExtraLight.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-ExtraLightItalic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Italic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Light.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-LightItalic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Medium.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-MediumItalic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Regular.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-SemiBold.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-SemiBoldItalic.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-Thin.woff" crossorigin="anonymous" />
    <link rel="preload" as="font" href="/assets/fonts/IBMPlexSans-ThinItalic.woff" crossorigin="anonymous" />
    <link rel="stylesheet" href="/assets/fonts.css" />
    <link rel="icon" sizes="32x32" type="image/svg+xml" href="/favicon.svg" />
  </head>

  <body>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <div id="root"></div>
    <script type="module" src="/src/index.tsx"></script>
  </body>

</html>